export default defineNuxtRouteMiddleware((to, from) => {
  const visitorSession = useVisitorSession()
  // console.log('mustViewingOwnDashboard middleware', visitorSession.user_id, to.params)
  if (!to.params.userId) {
    // console.log('user id params missing, redirecting to /dashboard/', visitorSession.user_id)
    // to.params.userId = String(visitorSession.user_id)
    // console.log(to)
    
    return { path: `/dashboard/${visitorSession.user_id}`, query: to.query }
    // return to
  }
  if (!visitorSession.realAdmin && visitorSession.user_id !== Number(to.params.userId)) {
    return { path: `/dashboard/${visitorSession.user_id}`, query: to.query }
  }
})
